import useStore from '@/lib/store';
import { Navigate, Outlet } from 'react-router-dom';

interface PrivateRouteProps {
  permission: string;
  redirectPath?: string;
}

export const PrivateRoute = ({
  permission,
  redirectPath = '/',
}: PrivateRouteProps) => {
  const { user } = useStore();
  if (!user?.permissions?.includes(permission)) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};
